export interface AppSpecs {
  'specs.funnel.TemplatesGalleryDisablePreviewModal': 'true' | 'false';
  'specs.funnel.TemplatesGalleryEnableSortingDesktop': 'true' | 'false';
  'specs.funnel.TemplatesGalleryEnableFilters': 'true' | 'false';
  'specs.funnel.TemplatesGalleryLeftNav': 'true' | 'false';
  'specs.TemplateCMS.book_templates-page-2-0_sports-fitness-main-cat': 'true' | 'false';
  'specs.funnel.TemplatesGalleryEnableBanner': 'true' | 'false';
  'specs.funnel.TemplatesGalleryEnableSeoSection': 'true' | 'false';
  'specs.funnel.TemplatesGalleryUseReactDomHydrate': 'true' | 'false';
  'specs.funnel.TemplatesGalleryNewMobileFlow': 'true' | 'false';
  'specs.funnel.TemplatesGalleryEnableLinkHeader': 'true' | 'false';
  'specs.funnel.TemplatesGalleryPreloadAssetsBeforeRender': 'true' | 'false';
}

export const defaultAppSpecs: AppSpecs = {
  'specs.funnel.TemplatesGalleryDisablePreviewModal': 'false',
  'specs.funnel.TemplatesGalleryEnableSortingDesktop': 'false',
  'specs.funnel.TemplatesGalleryEnableFilters': 'false',
  'specs.funnel.TemplatesGalleryLeftNav': 'false',
  'specs.TemplateCMS.book_templates-page-2-0_sports-fitness-main-cat': 'false',
  'specs.funnel.TemplatesGalleryEnableBanner': 'false',
  'specs.funnel.TemplatesGalleryEnableSeoSection': 'true',
  'specs.funnel.TemplatesGalleryUseReactDomHydrate': 'false',
  'specs.funnel.TemplatesGalleryNewMobileFlow': 'false',
  'specs.funnel.TemplatesGalleryEnableLinkHeader': 'false',
  'specs.funnel.TemplatesGalleryPreloadAssetsBeforeRender': 'false',
};
